// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Menu, Icon, Button } from 'semantic-ui-react'
import fire from '../config/Fire'

export default class SideBarMenuAuth extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: null
    }
  }

  logout () {
    fire.auth().signOut()
    window.scrollTo(0, 0)
  }

  render () {
    return (
      <Menu
        tabular
        fluid
        vertical
        borderless
        inverted
        style={{
          border: 'none',
          borderRadius: 0,
          boxShadow: 'none',
          marginBottom: '0em',
          backgroundColor: '#000',
          color: '#fff'
        }}>

        <Menu.Item>
          <h3 style={{ color: '#fff' }}>Main</h3>
        </Menu.Item>
        <Menu.Item href='/maker'>
          <Icon name='lab' style={{ color: '#fff' }} />
          Screens
        </Menu.Item>
        <Menu.Item href='/maker/navigation'>
          <Icon name='map signs' style={{ color: '#fff' }} />
          Navigation
        </Menu.Item>
        <Menu.Item href='/app/style'>
          <Icon name='pencil alternate' style={{ color: '#fff' }} />
          App Style
        </Menu.Item>

        <Menu.Item>
          <h3 style={{ color: '#fff' }}>Extensions</h3>
        </Menu.Item>
        <Menu.Item href='/sheets'>
          <Icon name='table' style={{ color: '#fff' }} />
          Google Sheets
        </Menu.Item>
        <Menu.Item href='/manage/wordpress'>
          <Icon name='wordpress simple' style={{ color: '#fff' }} />
          WordPress Blog
        </Menu.Item>
        <Menu.Item href='/manage/woocommerce'>
          <Icon name='cart' style={{ color: '#fff' }} />
          WooCommerce API
        </Menu.Item>
        <Menu.Item href='/manage/auth'>
          <Icon name='group' style={{ color: '#fff' }} />
          User Management
        </Menu.Item>
        <Menu.Item href='/manage/admob'>
          <Icon name='google' style={{ color: '#fff' }} />
          AdMob Banner
        </Menu.Item>

        <Menu.Item>
          <h3 style={{ color: '#fff' }}>Account</h3>
        </Menu.Item>
        <Menu.Item href='/dashboard'>
          <Icon name='book' style={{ color: '#fff' }} />
          Dashboard
        </Menu.Item>
        <Menu.Item href='/settings'>
          <Icon name='settings' style={{ color: '#fff' }} />
          Settings
        </Menu.Item>
        <Menu.Item>
          <Button href='/download' style={{ backgroundColor: '#f7d170', color: '#000' }}>
            <Icon name='download' />
            Download
          </Button>
        </Menu.Item>
        <Menu.Item>
          <Button onClick={this.logout} href='/' inverted basic>
            <Icon name='log out' />
            Log out
          </Button>
        </Menu.Item>
      </Menu>
    )
  }
}
